import { createFileRoute } from '@tanstack/react-router'

import { UsersListPage } from '#features/admin/users/users-list-page'

export const Route = createFileRoute('/_app/admin/users')({
  component: UsersListPage,
})
